<template>
    <div class="column is-one-third">
        <table class="table is-fullwidth">
            <tr>
                <th>Costs:</th>
                <td><input v-model="cost" class="input" type="number"></td>
            </tr>
            <tr>
                <th>Sales:</th>
                <td><input v-model="sales" class="input" type="number"></td>
            </tr>
            <tr>
                <th>Profit:</th>
                <td><input v-model="profit" class="input" type="number"></td>
            </tr>
        </table>
    </div>
</template>

<script>
    export default {
        computed: {
            cost: {
                get() {
                    return this.$store.getters.getCustomInvoice.cost
                },
                set(value) {
                    this.$store.dispatch('changeCustomInvoiceFieldValue', { field: 'cost', value: value })
                }
            },
            sales: {
                get() {
                    return this.$store.getters.getCustomInvoice.sales
                },
                set(value) {
                    this.$store.dispatch('changeCustomInvoiceFieldValue', { field: 'sales', value: value })
                }
            },
            profit: {
                get() {
                    return this.$store.getters.getCustomInvoice.profit
                },
                set(value) {
                    this.$store.dispatch('changeCustomInvoiceFieldValue', { field: 'profit', value: value })
                }
            }
        }
    }
</script>

<style scoped>
    td {
        font-size: large;
    }
    th {
        font-size: small;
    }
</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/Invoices/CustomInvoice/CustomInvoiceTotal.vue